import type { RouteObject } from "react-router-dom";

/*
  F06 web_capabilities: the Capabilities view of the 2026-11-03 design (rebuild package 4.4F). It loads when it is first opened.
  Who may open the address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [{ path: "/capabilities", lazy: async () => ({ Component: (await import("./CapabilitiesView")).CapabilitiesView }) }];
